export default function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/getPrototypeOf.js
// module id = 264
// module chunks = 0